/* Storefront theme: motion & effects engine (Theme settings → Animations & effects).
   Everything here is decoration. If this file never loads, the store works exactly the same. */
(function () {
  'use strict';
  var d = document;
  var w = window;
  var html = d.documentElement;
  var C = (w.SF && w.SF.fx) || {};
  var level = C.level || 'crazy';
  var mq = function (q) { return !!(w.matchMedia && w.matchMedia(q).matches); };
  if (level === 'off' || mq('(prefers-reduced-motion: reduce)') || !('IntersectionObserver' in w)) return;

  var crazy = level === 'crazy';
  var fine = mq('(hover: hover) and (pointer: fine)');
  var mobile = !mq('(min-width: 750px)');
  var raf = function (fn) { return w.requestAnimationFrame(fn); };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  /* querySelectorAll that also checks the root element itself (theme editor re-renders a section as the root) */
  function all(sel, root) {
    root = root || d;
    var list = Array.prototype.slice.call(root.querySelectorAll(sel));
    if (root !== d && root.matches && root.matches(sel)) list.unshift(root);
    return list;
  }

  html.classList.add('fx-on', crazy ? 'fx-crazy' : 'fx-subtle');

  /* ---------- Only animate sections that are on screen (saves battery, no lag) ---------- */
  var secIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('fx-in', e.isIntersecting); });
  }, { rootMargin: '150px 0px' });
  function watchSections(root) { all('.shopify-section', root).forEach(function (s) { secIO.observe(s); }); }

  /* ---------- Headings: letters fly in (crazy) ---------- */
  function splitText(el) {
    if (el._split || el.children.length) return false;
    var text = (el.textContent || '').trim();
    if (!text || text.length > 90) return false;
    el._split = true;
    // Screen readers use the label; the letters below are hidden from them (no duplicate text for search engines)
    el.setAttribute('aria-label', text);
    var wrap = d.createElement('span');
    wrap.className = 'split';
    wrap.setAttribute('aria-hidden', 'true');
    var ci = 0;
    var words = text.split(/\s+/);
    words.forEach(function (word, wi) {
      var ws = d.createElement('span');
      ws.className = 'split__w';
      Array.from(word).forEach(function (ch) {
        var cs = d.createElement('span');
        cs.className = 'split__c';
        cs.style.setProperty('--ci', ci++);
        cs.textContent = ch;
        ws.appendChild(cs);
      });
      wrap.appendChild(ws);
      if (wi < words.length - 1) wrap.appendChild(d.createTextNode(' '));
    });
    el.textContent = '';
    el.appendChild(wrap);
    return true;
  }
  function initSplit(root) {
    if (!crazy) return;
    var vh = w.innerHeight;
    all('.s-head h2, [data-split]', root).forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) return; // already visible: leave it calm
      if (splitText(el) && !el.closest('[data-reveal], .s-head')) el.setAttribute('data-reveal', 'none');
    });
  }

  /* ---------- Scroll reveal ---------- */
  var AUTO = '.s-head, .pcard, .ccard, .vcard, .fp, .acc, .contact, .rv-summary, .rv-grid .rv, .page-narrow > *';
  var revealIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in', 'is-anim');
      revealIO.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  function initReveal(root) {
    all(AUTO, root).forEach(function (el) {
      if (el.hasAttribute('data-reveal') || el.closest('.pp-section, .hero')) return;
      el.setAttribute('data-reveal', '');
      if (!el.style.getPropertyValue('--i')) {
        var i = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.style.setProperty('--i', Math.min(i, 6));
      }
    });
    var vh = w.innerHeight;
    all('[data-reveal]:not(.is-in)', root).forEach(function (el) {
      var r = el.getBoundingClientRect();
      // Already on screen when the page opens: show at once (no flicker)
      if (r.top < vh && r.bottom > 0) el.classList.add('is-in');
      else revealIO.observe(el);
    });
  }

  /* ---------- 3D tilt + light glare that follows the mouse ---------- */
  function initTilt(root) {
    if (!fine) return;
    all('[data-tilt], [data-spot]', root).forEach(function (el) {
      if (el._fx) return;
      el._fx = true;
      var g = d.createElement('span');
      g.className = 'fx-glare';
      g.setAttribute('aria-hidden', 'true');
      el.appendChild(g);
      var tilt = crazy && el.hasAttribute('data-tilt');
      var rect = null, ex = 0, ey = 0, pending = false;
      el.addEventListener('pointerenter', function () { rect = el.getBoundingClientRect(); el.classList.add('is-hover'); });
      el.addEventListener('pointermove', function (e) {
        ex = e.clientX; ey = e.clientY;
        if (pending) return;
        pending = true;
        raf(function () {
          pending = false;
          if (!rect) rect = el.getBoundingClientRect();
          var x = clamp((ex - rect.left) / rect.width, 0, 1);
          var y = clamp((ey - rect.top) / rect.height, 0, 1);
          el.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          el.style.setProperty('--my', (y * 100).toFixed(1) + '%');
          if (tilt) el.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * 9).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * 11).toFixed(2) + 'deg) translateY(-6px)';
        });
      });
      el.addEventListener('pointerleave', function () {
        rect = null;
        el.classList.remove('is-hover');
        if (tilt) el.style.transform = '';
      });
    });
  }

  /* ---------- Magnetic buttons (mouse only) ---------- */
  function initMagnetic(root) {
    if (!fine || !crazy) return;
    all('.btn, [data-magnetic], .header__icon, .round-btn', root).forEach(function (el) {
      if (el._mag || el.closest('[data-tilt]')) return;
      el._mag = true;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = clamp((e.clientX - r.left - r.width / 2) * 0.22, -10, 10);
        var y = clamp((e.clientY - r.top - r.height / 2) * 0.3, -7, 7);
        el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Animated cursor ring (computers only) ---------- */
  function initCursor() {
    if (!fine || !C.cursor || C.editor) return;
    var c = d.createElement('div');
    c.className = 'fx-cursor';
    c.setAttribute('aria-hidden', 'true');
    c.innerHTML = '<span class="fx-cursor__ring"><span class="fx-cursor__label"></span></span><span class="fx-cursor__dot"></span>';
    d.body.appendChild(c);
    var ring = c.firstChild, label = ring.firstChild, dot = c.lastChild;
    var mx = -200, my = -200, rx = -200, ry = -200, running = false, shown = false;
    function loop() {
      rx += (mx - rx) * 0.2;
      ry += (my - ry) * 0.2;
      ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0)';
      if (Math.abs(mx - rx) > 0.2 || Math.abs(my - ry) > 0.2) raf(loop);
      else running = false;
    }
    d.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0)';
      if (!shown) { shown = true; rx = mx; ry = my; c.classList.add('is-on'); }
      if (!running) { running = true; raf(loop); }
    }, { passive: true });
    d.addEventListener('pointerover', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var lab = t.closest('[data-cursor]');
      var link = t.closest('a, button, summary, label, [role="button"], .pill, input[type="submit"]');
      var field = t.closest('input:not([type="submit"]):not([type="radio"]):not([type="checkbox"]), textarea, select');
      c.classList.toggle('is-label', !!lab);
      c.classList.toggle('is-link', !!link && !lab);
      c.classList.toggle('is-field', !!field);
      label.textContent = lab ? lab.getAttribute('data-cursor') : '';
    });
    d.addEventListener('pointerdown', function () { c.classList.add('is-down'); });
    d.addEventListener('pointerup', function () { c.classList.remove('is-down'); });
    html.addEventListener('mouseleave', function () { shown = false; c.classList.remove('is-on'); });
  }

  /* ---------- Parallax: [data-parallax="0.2"] moves slower/faster than the page ---------- */
  var plx = [];
  var plxIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target._plxOn = e.isIntersecting; });
  }, { rootMargin: '200px 0px' });
  function initParallax(root) {
    if (!crazy) return;
    all('[data-parallax]', root).forEach(function (el) {
      if (el._plx) return;
      el._plx = true;
      el._plxSpeed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
      plx.push(el);
      plxIO.observe(el);
    });
  }
  function updateParallax(vh) {
    for (var i = 0; i < plx.length; i++) {
      var el = plx[i];
      if (!el._plxOn || !el.isConnected) continue;
      var r = (el.parentNode || el).getBoundingClientRect(); // measure the parent so our own movement never feeds back
      var off = (r.top + r.height / 2 - vh / 2) * -el._plxSpeed * (mobile ? 0.55 : 1);
      el.style.setProperty('--plx', off.toFixed(1) + 'px');
    }
  }

  /* ---------- Scroll velocity: text bands lean while you scroll ---------- */
  var velEls = [];
  function initVelocity(root) {
    if (!crazy) return;
    all('[data-velocity]', root).forEach(function (el) {
      if (el._vel) return;
      el._vel = true;
      velEls.push(el);
    });
  }

  /* ---------- Count-up numbers: [data-count="4551"] ---------- */
  var countIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      countIO.unobserve(e.target);
      runCount(e.target);
    });
  }, { threshold: 0.3 });
  function runCount(el) {
    var raw = String(el.getAttribute('data-count') || '');
    var target = parseFloat(raw.replace(/[^\d.]/g, ''));
    if (isNaN(target)) return;
    var dec = (raw.split('.')[1] || '').replace(/\D/g, '').length;
    var t0 = 0, dur = crazy ? 1800 : 1100;
    function fmt(v) { return v.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }
    // Reserve the final width first so the text beside the number never jiggles while it counts
    el.textContent = fmt(target);
    if (getComputedStyle(el).display === 'inline') el.style.display = 'inline-block';
    el.style.minWidth = el.getBoundingClientRect().width + 'px';
    el.style.textAlign = 'center';
    function step(t) {
      if (!t0) t0 = t;
      var k = clamp((t - t0) / dur, 0, 1);
      var e = k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
      el.textContent = fmt(target * e);
      if (k < 1) raf(step);
      else el.classList.add('is-done');
    }
    raf(step);
  }
  function initCounters(root) {
    all('[data-count]', root).forEach(function (el) {
      if (el._count) return;
      el._count = true;
      countIO.observe(el);
    });
  }

  /* ---------- Rotating words: [data-rotate="Trending|Viral|Premium"] ---------- */
  function initRotate(root) {
    /* Stacked words (hero): every word is already in the page, only visibility changes, so nothing moves */
    all('[data-rotate-stack]', root).forEach(function (el) {
      if (el._rot) return;
      el._rot = true;
      var words = Array.prototype.slice.call(el.children);
      if (words.length < 2) return;
      var i = 0;
      setInterval(function () {
        if (d.hidden || !el.isConnected) return;
        var cur = words[i];
        i = (i + 1) % words.length;
        var nxt = words[i];
        cur.classList.remove('is-on');
        cur.classList.add('is-off');
        nxt.classList.remove('is-off');
        nxt.classList.add('is-on');
        setTimeout(function () { cur.classList.remove('is-off'); }, 650);
      }, 2600);
    });
    all('[data-rotate]', root).forEach(function (el) {
      if (el._rot) return;
      el._rot = true;
      var words = String(el.getAttribute('data-rotate') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      var word = el.querySelector('.rot__w') || el;
      if (words.length < 2) return;
      var i = 0;
      setInterval(function () {
        if (d.hidden || !el.isConnected) return;
        word.classList.remove('is-in');
        word.classList.add('is-out');
        setTimeout(function () {
          i = (i + 1) % words.length;
          word.textContent = words[i];
          word.classList.remove('is-out');
          void word.offsetWidth;
          word.classList.add('is-in');
        }, 380);
      }, 2600);
    });
  }

  /* ---------- Confetti burst ---------- */
  var palette = null;
  function colors() {
    if (palette) return palette;
    var cs = getComputedStyle(html);
    palette = ['--c-primary', '--c-primary-2', '--c-star', '--c-primary-light'].map(function (v) {
      return cs.getPropertyValue(v).trim() || '#ff3355';
    }).concat(['#ffffff', '#ffd23f']);
    return palette;
  }
  function confetti(x, y) {
    var cv = d.createElement('canvas');
    cv.className = 'fx-confetti';
    cv.setAttribute('aria-hidden', 'true');
    var dpr = Math.min(2, w.devicePixelRatio || 1);
    var W = w.innerWidth, H = w.innerHeight;
    cv.width = W * dpr;
    cv.height = H * dpr;
    d.body.appendChild(cv);
    var ctx = cv.getContext('2d');
    if (!ctx) { cv.remove(); return; }
    ctx.scale(dpr, dpr);
    var cols = colors(), parts = [], n = mobile ? 70 : 110;
    for (var i = 0; i < n; i++) {
      var a = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.15;
      var s = 7 + Math.random() * 10;
      parts.push({
        x: x, y: y, vx: Math.cos(a) * s, vy: Math.sin(a) * s,
        r: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.45,
        w: 6 + Math.random() * 7, h: 8 + Math.random() * 9,
        c: cols[i % cols.length], k: i % 3
      });
    }
    var t0 = 0;
    function draw(t) {
      if (!t0) t0 = t;
      var life = (t - t0) / 1900;
      ctx.clearRect(0, 0, W, H);
      ctx.globalAlpha = clamp(1.4 - life * 1.4, 0, 1);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.vy += 0.34;
        p.vx *= 0.986;
        p.vy *= 0.986;
        p.x += p.vx + Math.sin((t - t0) / 180 + i) * 0.6;
        p.y += p.vy;
        p.r += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.r);
        ctx.fillStyle = p.c;
        if (p.k === 0) ctx.fillRect(-p.w / 2, -p.h / 4, p.w, p.h / 2);
        else if (p.k === 1) { ctx.beginPath(); ctx.arc(0, 0, p.w / 2.3, 0, 6.283); ctx.fill(); }
        else { ctx.beginPath(); ctx.moveTo(0, -p.h / 2); ctx.lineTo(p.w / 2, p.h / 2); ctx.lineTo(-p.w / 2, p.h / 2); ctx.closePath(); ctx.fill(); }
        ctx.restore();
      }
      if (life < 1) raf(draw);
      else cv.remove();
    }
    raf(draw);
  }
  w.SFConfetti = confetti;
  var CONFETTI = '[data-confetti], .pp [data-cta] button, .pp [data-cta] [type="submit"], [data-sticky-go], [data-mbx-open], .hero__ctas .btn';
  if (C.confetti) {
    d.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest(CONFETTI);
      if (!t) return;
      var r = t.getBoundingClientRect();
      var x = e.clientX || r.left + r.width / 2;
      var y = e.clientY || r.top + r.height / 2;
      confetti(x, y);
    }, true);
  }

  /* ---------- Mystery box: lid pops open, then go ---------- */
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-mbx-open]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href === '#' || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var card = a.closest('.mbx');
    if (!card || card.classList.contains('is-opening')) return;
    e.preventDefault();
    card.classList.add('is-opening');
    setTimeout(function () { location.href = href; }, 520);
  });

  /* ---------- Button ripple ---------- */
  d.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('.btn');
    if (!b) return;
    var r = b.getBoundingClientRect();
    var size = Math.max(r.width, r.height);
    var s = d.createElement('span');
    s.className = 'ripple';
    s.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + (e.clientX - r.left - size / 2) + 'px;top:' + (e.clientY - r.top - size / 2) + 'px';
    b.classList.add('is-ripple');
    b.appendChild(s);
    setTimeout(function () { s.remove(); }, 650);
  });

  /* ---------- One scroll loop for everything (progress bar, header, parallax, velocity, back-to-top) ---------- */
  var header = d.querySelector('[data-header]');
  var headerSec = header && (header.closest('.section-header') || header);
  var bar = d.querySelector('[data-fx-progress]');
  var topBtn = d.querySelector('[data-fx-top]');
  var ringEl = topBtn && topBtn.querySelector('[data-fx-ring]');
  var lastY = w.scrollY, vel = 0, ticking = false;
  if (headerSec && header) headerSec.style.setProperty('--hh', header.offsetHeight + 'px');

  function frame() {
    ticking = false;
    var y = w.scrollY;
    var vh = w.innerHeight;
    var max = Math.max(1, html.scrollHeight - vh);
    var p = clamp(y / max, 0, 1);
    if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    if (topBtn) {
      topBtn.classList.toggle('is-show', y > 700);
      if (ringEl) ringEl.style.strokeDashoffset = (100 - p * 100).toFixed(2);
    }
    var dy = y - lastY;
    if (header) {
      header.classList.toggle('is-scrolled', y > 10);
      if (C.headerHide && headerSec) {
        var menuOpen = !!header.querySelector('details[open]');
        if (!menuOpen && y > 200 && dy > 5) headerSec.classList.add('is-hidden');
        else if (menuOpen || dy < -5 || y < 200) headerSec.classList.remove('is-hidden');
      }
    }
    updateParallax(vh);
    if (velEls.length) {
      vel += (clamp(dy / 36, -1, 1) - vel) * 0.25;
      if (Math.abs(vel) < 0.003) vel = 0;
      for (var i = 0; i < velEls.length; i++) velEls[i].style.setProperty('--vel', vel.toFixed(3));
      if (vel !== 0 && !ticking) { ticking = true; raf(frame); }
    }
    lastY = y;
  }
  function onScroll() { if (!ticking) { ticking = true; raf(frame); } }
  w.addEventListener('scroll', onScroll, { passive: true });
  w.addEventListener('resize', function () {
    mobile = !mq('(min-width: 750px)');
    if (headerSec && header) headerSec.style.setProperty('--hh', header.offsetHeight + 'px');
    onScroll();
  }, { passive: true });
  if (topBtn) topBtn.addEventListener('click', function () { w.scrollTo({ top: 0, behavior: 'smooth' }); });

  function initAll(root) {
    watchSections(root);
    initSplit(root);
    initReveal(root);
    initTilt(root);
    initMagnetic(root);
    initParallax(root);
    initVelocity(root);
    initCounters(root);
    initRotate(root);
  }
  initCursor();
  initAll(d);
  frame();
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); onScroll(); });
})();
